import  {cnProd}  from '../environments/environment.cn.prod';
import { cnqa1 } from '../environments/environment.cn.qa1';
import { qa } from '../environments/environment.qa';
import { qa4 } from '../environments/environment.qa4';
import { prod } from '../environments/environment.prod';




const { hostname } = window.location;
let sufix = '_LOCAL';
let environment = '';
if (hostname.includes('localhost')) {
  sufix = '_LOCAL';
  environment = qa4;
} else if (hostname.includes('www.thermofisher.cn')) {
  sufix = '_PRODCN';
  environment = cnProd;
} else if (hostname.includes('qa1.thermofisher.cn')) {
  sufix = '_QACN';
  environment = cnqa1;
}  else if (hostname.includes('www.qa.thermofisher.com') || hostname.includes('qa-identity.thermofisher.com')) {
  sufix = '_QA';
  environment = qa;
} else if (hostname.includes('www.qa4.thermofisher.com') || hostname.includes('dev-identity.thermofisher.com')) {
  sufix = '_QA4';
  environment = qa4;
} else if (hostname.includes('www.thermofisher.com') || hostname.includes('identity.thermofisher.com')) {
  sufix = '_PROD';
  environment = prod;
}



const SERVICE_URL = process.env[`REACT_APP_SERVICE_URL${sufix}`];
const PUBLIC_URL = process.env[`REACT_APP_PUBLIC_URL${sufix}`];

const config = {
  serviceUrl: SERVICE_URL,
  publicUrl: PUBLIC_URL,
  environment: environment,
  ENV_SUFIX: sufix
};

export default config;
